{
  "dismissedMessage": "Anfrage für {{tailNumber}} abgelehnt",
  "dismissError": "Anfrage konnte nicht verworfen werden. Bitte versuche es erneut.",
  "emptyState": "Keine ausstehenden Kennzeichen-Anfragen",
  "unknown": "Unbekannt",
  "headers": {
    "tailNumber": "Kennzeichen",
    "fboName": "FBO-Name",
    "requestedBy": "Angefordert von",
    "requestedAt": "Angefragt am",
    "actions": "Aktionen"
  },
  "dismissTooltip": "Diese Anfrage ablehnen"
}
